import {Link, RelativeTime} from '@primer/react'
import {Tooltip} from '@primer/react/next'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {GitHubAvatar} from '@github-ui/github-avatar'

import styles from './UpdatedBy.module.css'

interface UpdatedByProps {
  user?: {
    login: string
    name: string
    path: string
    avatarUrl: string
  }
  updatedAt: string
  deletedAt?: string
}

export function UpdatedBy({user, updatedAt, deletedAt = undefined}: UpdatedByProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  return (
    <div className={styles.Container}>
      {user &&
        (user.path.startsWith('/apps/') ? (
          <Tooltip text={user.name}>
            <Link href={user.path} className={styles.UserLink}>
              <GitHubAvatar
                aria-label={user.login}
                src={user.avatarUrl}
                alt={user.login}
                size={16}
                square
                className={styles.GitHubAvatar}
              />
            </Link>
          </Tooltip>
        ) : (
          <Link
            href={user.path}
            {...getHovercardAttributesForType('user', {login: user.login})}
            className={styles.UserLink}
          >
            <GitHubAvatar
              aria-label={user.login}
              src={user.avatarUrl}
              alt={user.login}
              size={16}
              square={false}
              className={styles.GitHubAvatar}
            />
          </Link>
        ))}
      {deletedAt && <span>Deleted</span>}&nbsp;
      <RelativeTime datetime={deletedAt || updatedAt} tense="past" />
    </div>
  )
}
